<template>
    <div class="text v-flex" :style="alignText">
        <a @click="onCopy">
            <div ref="text" class="mr-1 text" :class="color" >{{ text }}</div>
        </a>
    </div>
</template>

<script>
import Core from "@/modules/core/service/Core";

export default {
    name: "FCopyText",
    props: {
        text: {

        },

        color: {

        },

        right: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
        copy: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    computed: {
        alignText () {
            if (!this.right) {
                return null;
            }

            return "justify-content: flex-end;";
        }
    },

    methods: {
        onCopy () {
            const range = document.createRange();
            range.selectNodeContents(this.$refs.text);
            const selection=window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            navigator.clipboard.writeText(this.text);
            Core.message.hint(this, this.text + " wurde ins Clipboard kopiert!")
        }
    }
}
</script>

<style scoped>

.text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.text a {
    max-width: 100%;
    width: 100%;
}

</style>